import React, { useEffect, useState } from "react";
import styles from "./Feed.module.scss";
import { connect } from "react-redux";
import { openFeedTextModal, closeMainModal, getPosteos, getOwnPosteos } from "../../../store/actions";
import usePremiumCheck from "../../../hooks/usePremiumCheck";
import FeedCard from "./FeedCard";
import { ReactComponent as Foto } from "../../../assets/svg/fotoAdd.svg";
import { ReactComponent as Video } from "../../../assets/svg/addVideo.svg";
import { ReactComponent as ArrowDown } from "../../../assets/svg/arrowDownIcon.svg";
import { ReactComponent as ArrowUp } from "../../../assets/svg/arrowUpIcon.svg";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"


const Feed = ({
    userData,
    openFeedTextModal,
    closeMainModal,
    getPosteos,
    getOwnPosteos,
    ownPosteos,
    posteos,
    ...props }) => {
    const [selectedOption, setSelectedOption] = useState("recomendados");
    const [showMenu, setShowMenu] = useState(false);
    const [myPosts, setMyPosts] = useState(false);
    const premiumCheck = usePremiumCheck();

    //Carga los posteos
    useEffect(() => {
        getPosteos("DESC", "MG");
    }, []);

    //Abre el modal de texto
    const handleOpenMainModalTxt = () => {
        openFeedTextModal({
            text: true,
        });
    };

    //Abre el modal de imagen
    const handleOpenMainModalWithImg = () => {
        openFeedTextModal({
            image: true,
        });
    }

    //Abre el modal de video
    const handleOpenMainModalWithVideo = () => {
        openFeedTextModal({
            video: true,
        });
    };

    //Menu de opciones de visualizacion
    const handleOptionClick = (option) => {
        setSelectedOption(option);

        if (option === "reciente") {
            setMyPosts(false);
            getPosteos("DESC", "DATE");
        }
        if (option === "recomendados") {
            setMyPosts(false);
            getPosteos("DESC", "MG");
        }
        if (option === "propios") {

            getOwnPosteos(userData.id);
            setMyPosts(true);
        }
        setShowMenu(false);
    };

    const userFullName = userData.type === "COMPANY" ? userData.razon_social : userData.name + " " + userData.last_name;

    return (
        <div className={styles.container}>
            <div className={styles.feed}>
                <div className={styles.feed_header}>
                    <div className={styles.feed_itemHeader_imgContainer}>
                        <img src={userData.image_profile} alt="" />
                        <p className={styles.feed_itemHeader_userData}>
                            {userFullName}
                        </p>
                        <div className={styles.feed_itemHeader_userData_status}></div>
                    </div>
                    <header className={styles.header}>
                        <div className={styles.header_titleSortContainer}>
                            <h2 className={styles.header_title}>FEED</h2>
                            <div className={styles.dropdown}>

                                <button className={styles.dropdown_button} onClick={() => setShowMenu(!showMenu)}>
                                    {showMenu ? <ArrowUp width={10} height={10} /> : <ArrowDown width={10} height={10} />}
                                    {selectedOption === "reciente"
                                        ? "Reciente"
                                        : selectedOption === "propios"
                                            ? "Propios"
                                            : "Recomendados"}
                                </button>
                                {showMenu && (
                                    <>
                                        <div className={styles.dropdown_content}>
                                            <button
                                                onClick={() => handleOptionClick("reciente")}
                                                className={styles.dropdown_option}
                                            >
                                                Reciente
                                            </button>
                                            <button
                                                onClick={() => handleOptionClick("propios")}
                                                className={styles.dropdown_option}
                                            >
                                                Propios
                                            </button>
                                            <button
                                                onClick={() => handleOptionClick("recomendados")}
                                                className={styles.dropdown_option}
                                            >
                                                Recomendados
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </header>
                </div>
                <div className={styles.feed_itemHeader}>
                    <div className={styles.feed_itemHeader_subTitleContainer}>
                        <h4 className={styles.feed_itemHeader_subTitle}>Crear artículo</h4>
                    </div>
                    <div className={styles.feed_input} onClick={premiumCheck(handleOpenMainModalTxt)}>
                        <input type="text"
                            placeholder={"¿Qué querés compartir con la comunidad?"}
                            className={styles.feed_input_item} />
                        <div className={styles.feed_itemFooterContainer} >
                            <div className={styles.feed_itemFooterLeft} onClick={premiumCheck(handleOpenMainModalWithImg)}>
                                <Foto width={20} height={20} />
                                <input type="file" name="file" id="file" className={styles.feed_itemFooterLeft_input} />
                            </div>
                            <div className={styles.feed_itemFooterRight} onClick={premiumCheck(handleOpenMainModalWithVideo)}>
                                <Video width={20} height={20} />
                                <input type="file" name="file" id="file" className={styles.feed_itemFooterRight_input} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.feedItemContainer}>
            <ResponsiveMasonry
                columnsCountBreakPoints={{300: 1, 600: 2, 1400: 3}}
                
            >
                <Masonry
                gutter="10px"
                >
                    {myPosts ? ownPosteos.map((item) => (
                        <FeedCard key={item.id} item={item} myPosts={myPosts} />
                    )) : (posteos.map((item) => (
                        <FeedCard key={item.id} item={item} myPosts={myPosts} />
                    )))}
                    
                </Masonry>
            </ResponsiveMasonry>
        </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        userData: state.general.userData,
        posteos: state.dashboard.posteos,
        ownPosteos: state.dashboard.ownPosteos,
    };
};

export default connect(mapStateToProps, { openFeedTextModal, closeMainModal, getPosteos, getOwnPosteos })(Feed);
